import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlCloseFeedbackIcon } from '»components/atoms';

import {
  DescriptionContainerStyled,
  DescriptionStyled,
  ErrorContainerStyled,
  ErrorIconStyled,
  HeaderContainerStyled,
  TextContainerStyled,
  TitleStyled,
} from './TrlErrorContainer.styles';

export const TrlErrorContainer = memo(({ showContainer, errorMessage }) => {
  const [show, setShow] = useState(showContainer);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (showContainer !== show) setShow(showContainer);
  }, [showContainer]);

  const handleClose = () => {
    setShow(false);
  };

  if (show)
    return (
      <ErrorContainerStyled id="divFeedback">
        <ErrorIconStyled icon={faCircleXmark} />
        <TextContainerStyled>
          <HeaderContainerStyled>
            <TitleStyled>
              <FormattedMessage id="TRLT_UI-ORD_ERROR" />
            </TitleStyled>
            <TrlCloseFeedbackIcon onClick={handleClose} />
          </HeaderContainerStyled>
          <DescriptionContainerStyled>
            <DescriptionStyled>{errorMessage}</DescriptionStyled>
          </DescriptionContainerStyled>
        </TextContainerStyled>
      </ErrorContainerStyled>
    );

  return null;
});

TrlErrorContainer.displayName = 'TrlErrorContainer';

TrlErrorContainer.propTypes = {
  showContainer: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
};
